import React, { ComponentType, FC, useEffect } from 'react';
import { useAuth0 } from '@auth0/auth0-react';
import { WithAuthenticationRequiredOptions } from '@auth0/auth0-react/src/with-authentication-required';
import { isUsingMagicLinkAuthen } from '../../../helpers';
import { LEGACY_PORTAL_URL } from '../../../constants/legacy';

const withAuthenticationRequired = <P extends object>(
  Component: ComponentType<P>,
  _options: WithAuthenticationRequiredOptions = {}
): FC<P> => {
  return function WithLegacyRedirect(props: P): JSX.Element {
    const isMagicLinkFlow = isUsingMagicLinkAuthen();
    const { isAuthenticated, isLoading } = useAuth0();

    useEffect(() => {
      if (!isMagicLinkFlow && !isLoading && !isAuthenticated) {
        window.location.replace(LEGACY_PORTAL_URL);
      }
    }, [isAuthenticated, isLoading, isMagicLinkFlow]);

    if (isMagicLinkFlow) {
      return <Component {...props} />;
    }

    if (!isAuthenticated) {
      return <></>;
    }

    return <Component {...props} />;
  };
};

export { withAuthenticationRequired };
